import {requireOptionalNativeModule} from 'expo-modules-core';
import Constants, {AppOwnership} from 'expo-constants';

const ExpoUpdates = requireOptionalNativeModule('ExpoUpdates');
const isRunningInExpoGo = Constants.appOwnership === AppOwnership.Expo;
// expo-updates (and Expo Go expo-updates override) manages assets from updates and exposes
// the ExpoUpdates.localAssets constant containing information about the assets.
const expoUpdatesIsInstalledAndEnabled = !!ExpoUpdates?.isEnabled;
const expoUpdatesIsUsingEmbeddedAssets = ExpoUpdates?.isUsingEmbeddedAssets;
// if expo-updates is installed but we're running directly from the embedded bundle, we don't want
// to override the AssetSourceResolver.
const shouldUseUpdatesAssetResolution = expoUpdatesIsInstalledAndEnabled && !expoUpdatesIsUsingEmbeddedAssets;
// Expo Go always uses the updates module for asset resolution (local assets) since it
// overrides the expo-updates module.
export const IS_ENV_WITH_LOCAL_ASSETS = isRunningInExpoGo || shouldUseUpdatesAssetResolution;

export function getLocalAssets() {
    return {};
}
export function getManifest2() {
    return {};
}
// Compute manifest base URL if available
export const manifestBaseUrl = null;
//# sourceMappingURL=PlatformUtils.web.js.map